module.exports = __webpack_public_path__ + "static/media/intro.7b724470.mp3";